import type { FormSchema } from '../designer/types/form.types'

export function schemaHasCommandBar(nodes: FormSchema['root'] | undefined): boolean {
  if (!nodes?.length) return false
  const walk = (list: FormSchema['root']): boolean => {
    for (const n of list) {
      if (n.type === 'CommandBar') return true
      if (n.children?.length && walk(n.children)) return true
    }
    return false
  }
  return walk(nodes)
}

/** Only root-level CommandBar (auto-gen item forms) — nested footer bars must not hide platform Save/Close. */
export function schemaHasRootCommandBar(nodes: FormSchema['root'] | undefined): boolean {
  if (!nodes?.length) return false
  return nodes.some((n) => n.type === 'CommandBar')
}
